module.exports = __webpack_public_path__ + "static/media/ic_resolution.43e937ec.svg";